import React, { useState } from "react";
import Axios from "axios";
import { useSupplierContext } from "../../../context/SupplierContext";
import "./newSupplier.css";

const NewSupplier = () => {
  const [formData, setFormData] = useState({
    full_name: "",
    phone: "",
    balance: 0,
    description: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const { suppliers, isFetching, fetchSuppliers } = useSupplierContext();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (!formData.full_name.trim()) return setError("اسم المورد مطلوب");
    if (!formData.phone.trim()) return setError("رقم الهاتف مطلوب");

    setIsLoading(true);
    try {
      const res = await Axios.post(
        `${process.env.REACT_APP_API_URL}/supplier/newSupplier.php`,
        formData
      );

      if (res.data.status === "success") {
        setMessage(res.data.message);
        fetchSuppliers(); // ✅ تحديث القائمة بعد الإضافة
        setFormData({
          full_name: "",
          phone: "",
          balance: 0,
          description: "",
        });
      } else {
        setError(res.data.message || "حدث خطأ أثناء الإضافة");
      }
    } catch (err) {
      setError(err.response?.data?.message || "فشل الاتصال بالسيرفر");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="supplier-page">
      {/* ✅ عرض الموردين */}
      <div className="supplier-list">
        <h2>🏢 الموردون الحاليون</h2>
        {isFetching ? (
          <p className="loading-text">جارٍ التحميل...</p>
        ) : suppliers.length === 0 ? (
          <p className="no-suppliers">لا يوجد موردون بعد</p>
        ) : (
          <ul>
            {suppliers.map((supplier) => (
              <li key={supplier.id}>
                <p>
                  الاسم: <strong>{supplier.full_name}</strong>
                </p>
                <p>
                  الهاتف: <span>{supplier.phone}</span>
                </p>
                <p>
                  الرصيد: <span>{supplier.balance} ₪</span>
                </p>
                {supplier.description && (
                  <p>
                    الوصف: <span>{supplier.description}</span>
                  </p>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* ✅ الفورم */}
      <div className="card-parent">
        <div className="new-supplier-card">
          <div className="new-supplier-header">
            <h1 className="new-supplier-title">إضافة مورد جديد</h1>
            <p className="new-supplier-subtitle">
              أدخل معلومات المورد الجديد ثم اضغط على زر الإضافة
            </p>
          </div>

          <form className="new-supplier-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="full_name" className="form-label">
                الاسم الكامل <span className="required">*</span>
              </label>
              <input
                type="text"
                id="full_name"
                name="full_name"
                className="form-input"
                placeholder="أدخل الاسم الكامل"
                value={formData.full_name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone" className="form-label">
                رقم الهاتف <span className="required">*</span>
              </label>
              <input
                type="text"
                id="phone"
                name="phone"
                className="form-input"
                placeholder="أدخل رقم الهاتف"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="balance" className="form-label">
                الرصيد الابتدائي
              </label>
              <input
                type="text"
                id="balance"
                name="balance"
                className="form-input"
                placeholder="0"
                value={formData.balance}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9.-]/g, "");
                  handleChange({ target: { name: "balance", value } });
                }}
              />
            </div>

            <div className="form-group">
              <label htmlFor="description" className="form-label">
                الوصف
              </label>
              <textarea
                id="description"
                name="description"
                className="form-input"
                placeholder="أدخل وصفاً اختياريًا"
                value={formData.description}
                onChange={handleChange}
                rows="3"
              ></textarea>
            </div>

            {error && <p className="error-message">{error}</p>}
            {message && <p className="success-message">{message}</p>}

            <button
              type="submit"
              className={`submit-button ${isLoading ? "loading" : ""}`}
              disabled={isLoading}
            >
              {isLoading ? (
                <div className="loading-spinner"></div>
              ) : (
                "إضافة المورد"
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewSupplier;
